import { Component, Input, OnInit } from '@angular/core';
import { PigeonholeService } from 'src/app/core/data-sources/v3/pigeonhole/pigeonhole.service';
import { setOccupationChartDataset } from 'src/app/helpers/chart-helper';
import { PigeonholeOccupationInfo } from 'src/models/Pigeonhole';
import * as moment from 'moment';

@Component({
  selector: 'app-pigeonhole-occupation-info',
  templateUrl: './pigeonhole-occupation-info.component.html',
  styleUrls: ['./pigeonhole-occupation-info.component.scss']
})
export class PigeonholeOccupationInfoComponent implements OnInit {
  @Input() id: string;
  occupationList = [];
  now;
  total = 0;
  usage = 0;
  public datasets = [{
    data: [10, 10],
    backgroundColor: ['#92B531', '#E8EBEF']
  }];
  chartLabels = ['Posições Ocupadas', 'Posições Livres'];
  window = window;
  occupationInfo: PigeonholeOccupationInfo = null;

  constructor(
    private pigeonholeService: PigeonholeService
  ) { }

  ngOnInit(): void {
    this.now = moment().format("DD-MM-yyyy");
    this.getOccupationInfo();
  }

  async getOccupationInfo() {
    this.occupationInfo = await this.pigeonholeService.getPigeonholeOccupationInfo(this.id);

    if (this.occupationInfo) {
      this.occupationList = [
        { id: 'occupied', name: 'Posições ocupadas', value: this.occupationInfo.totalOccupiedPigeonholes },
        { id: 'free', name: 'Posições livres', value: this.occupationInfo.totalFreePigeonholes },
        { id: 'total', name: 'Total de posições', value: this.occupationInfo.totalPigeonholes }
      ];

      this.datasets[0].data = setOccupationChartDataset(this.occupationList);
      this.total = this.occupationInfo.totalPigeonholes;
      const totalOccupied = this.occupationInfo.totalOccupiedPigeonholes;
      this.usage = this.total ? (totalOccupied / this.total) * 100 : 0;
    }
  }

}
